import { Alert, HeadingSection, VFlow } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { getLotacaoResponsavel } from 'components/lotacao-responsavel/utils/utils-lotacaoResponsavel'
import { NacionalidadeEnum } from 'graphql/types.generated'
import React, { useMemo } from 'react'

import { CidadaoFciForm } from './CidadaoFciForm'
import { CidadaoFciFormModel, PAIS_BRASIL } from './model-cidadaoFci'

export function CidadaoFciCreateView() {
  const { acesso, profissional } = useAcessoLotacaoOrEstagio()

  const defaultValues = useMemo(
    () =>
      ({
        dadosPessoais: {
          nacionalidadeCidadao: {
            nacionalidade: NacionalidadeEnum.BRASILEIRA,
          },
        },
        endereco: {
          pais: {
            id: PAIS_BRASIL.id,
            nome: PAIS_BRASIL.nome,
          },
        },
        responsabilidadeAcompanhamento: {
          responsavel: getLotacaoResponsavel(profissional, acesso.cbo, acesso.equipe, acesso.unidadeSaude, acesso.id),
        },
      } as CidadaoFciFormModel),
    [acesso.cbo, acesso.equipe, acesso.id, acesso.unidadeSaude, profissional]
  )

  return (
    <PageContent type='filled'>
      <Breadcrumb title='Cadastro do cidadão' />
      <HeadingSection level={1} title='Cadastro do cidadão' />
      <VFlow>
        <Alert type='info'>
          O módulo tem como objetivo atualizar ou registrar os dados cadastrais do cidadão no sistema. Esses dados
          também podem ser provenientes das informações da Ficha de Cadastro Individual ou Ficha de Avaliação de
          Elegibilidade após seu processamento.
        </Alert>
        <CidadaoFciForm initialValues={defaultValues} />
      </VFlow>
    </PageContent>
  )
}
